export const chartConfig = {
  '1D': { days: 1, weeks: 0, months: 0, years: 0, resolution: '1' },
  '1W': { days: 0, weeks: 1, months: 0, years: 0, resolution: '15' },
  '1M': { days: 0, weeks: 0, months: 1, years: 0, resolution: '60' },
  '1Y': { days: 0, weeks: 0, months: 0, years: 1, resolution: 'D' },
};

// Finnhub api requires resolution keys to be passed as argument.
